import { Flex, Typography } from 'antd';
import { useParams } from "react-router-dom";
import { useOnayBilimStatus } from '../../../utils/useOnayBilimStatus';
import './FooterInfo.css';

export const FooterInfo = () => {
    const params = useParams()
    const onayBilimIntegration = useOnayBilimStatus(params.id || null);

    return (
        <div className="FooterInfo">
            {onayBilimIntegration ? (
                <Flex vertical style={{padding: '12px 0',alignItems: 'center',}} gap={4}>
                    <Typography.Text style={{ fontSize: 14, color: "#BDBDBD", fontFamily: "Source Sans Pro" }} >Единый номер</Typography.Text>
                    <Typography.Link style={{ fontSize: 18, color: "#C0C0C0", fontFamily: "Source Sans Pro" }} href='tel:+77006964394'>+7 700 696 43 94</Typography.Link>
                    <Typography.Text style={{ fontSize: 14, color: "#BDBDBD", fontFamily: "Source Sans Pro" }} >Whatsapp и Telegram</Typography.Text>
                </Flex>
            ) : (
                <>
                    <p className="mobileWrapText">Единый номер</p>
                    <h3 className="telephone">+7 727 390 11 12</h3>
                    <p className="support">служба поддержки пользователей</p>
                </>
            )}
            <div className="socialIcons">
                <div className="social-instagram" />
                <div className="social-meta" />
                <div className="social-linkedin" />
                <div className="social-youtube" />
            </div>
        </div>
    )
}